<template>
  <v-container id="taxslab-edit" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="10">
        <v-form v-model="validConsig" ref="form">
          <v-card>
            <v-card-text>
              <v-container class="py-0">
                <v-row class="mt-4">
                  <v-col cols="12" sm="6" md="3" lg="2">
                    <v-select
                      :label="$i18n.t('Type')"
                      :items="[
                        { name: 'Consignor', value: 1 },
                        { name: 'Consignee', value: 2 },
                      ]"
                      item-text="name"
                      item-value="value"
                      v-model="consig.type"
                      :disabled="type == 1 || type == 2"
                    />
                  </v-col>

                  <v-col cols="12" sm="6" md="3" lg="4">
                    <v-text-field
                      :label="$i18n.t('Name')"
                      v-model="consig.name"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6" md="3" lg="3">
                    <z-country-select
                      :label="$i18n.t('Country Code') + '*'"
                      class="purple-input"
                      v-model="consig.countryCode"
                      isd
                      hideName
                    />
                  </v-col>
                  <v-col cols="12" sm="6" md="3" lg="3">
                    <v-text-field
                      :label="$i18n.t('Phone')"
                      type="number"
                      v-model="consig.phone"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6" md="3" lg="3">
                    <v-text-field
                      :label="$i18n.t('Email')"
                      v-model="consig.email"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6" md="3" lg="3">
                    <v-text-field
                      :label="$i18n.t('GSTIN')"
                      v-model="consig.gstin"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6" md="3" lg="3">
                    <z-country-select
                      class="purple-input"
                      v-model="consig.address.country"
                    ></z-country-select>
                  </v-col>

                  <v-col cols="12" sm="6" md="3" lg="3">
                    <z-state-select
                      class="purple-input"
                      v-model="consig.address.state"
                      :country="consig.address.country"
                    ></z-state-select>
                  </v-col>

                  <v-col cols="12" md="4">
                    <z-city-select
                      class="purple-input"
                      v-model="consig.address.city"
                      :state="consig.address.state"
                      :country="consig.address.country"
                    ></z-city-select>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-text-field
                      :label="$i18n.t('Address')"
                      v-model="consig.address.addressLine"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="2">
                    <v-text-field
                      :label="$i18n.t('Pincode')"
                      type="number"
                      v-model="consig.address.pinCode"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <small>*indicates required field</small>
              <v-spacer></v-spacer>
              <v-btn
                color="success darken-1"
                @click="saveConsig()"
                :loading="loading"
                :disabled="!validConsig"
                >Save</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import { Vue, Component } from "vue-property-decorator";

@Component({
  name: "ConsignorCreate",
  props: {
    consig_id: {
      default: null,
    },
    singlePage: {
      default: false,
    },
    type: {
      default: null,
    },
  },
})
export default class ConsignorCreate extends Vue {
  validConsig = true;
  isClone = null;
  isEdit = false;
  consignorPOSO = {
    corp_id: null,
    name: null,
    countryCode: 91,
    gstin: null,
    phone: null,
    email: null,
    type: null,
    address: {
      country: "India",
      state: null,
      city: null,
      addressLine: null,
      pinCode: null,
    },
  };

  consig = this.consignorPOSO;

  select(data) {
    this.$emit("select", data);
  }

  closeDialog() {
    this.$emit("closeDialog", false);
  }

  validationrules = {
    name: [(v) => !!v || this.$i18n.t("Name is required")],
    type: [(v) => !!v || this.$i18n.t("Type is required")],
  };

  get loading() {
    return common.loading;
  }

  async saveConsig() {
    try {
      common.setLoading(true);
      const response = await doPost("/api/consignor/save", this.consig);
      common.showMessage(`Saved Successfully`);
      common.setLoading(false);

      if (this.singlePage) {
        this.$emit("select", response);
        this.consig = this.consignorPOSO;
        this.closeDialog();
      } else {
        if (!this.consig_id) this.$router.push("/consignor/" + response._id);
        this.consig_id = response._id;
        this.get();
      }
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  async get() {
    try {
      this.consig = await doGet("/api/consignor/" + this.consig_id + "/detail");
      this.consig_id = this.consig._id;
    } catch (e) {
      common.setError(e.message);
    }
  }

  async mounted() {
    if (this.singlePage) {
      if (this.consig_id) {
        await this.get();
      } else {
        this.consig.type = this.type;
      }
    } else if (this.$route.params.id) {
      this.consig_id = this.$route.params.id;
      await this.get();
    } else if (this.$route.params.clone_id) {
      this.isClone = true;
      this.consig_id = this.$route.params.clone_id;
      await this.get();
      this.consig._id = null;
      this.consig.version = null;
    }
  }
}
</script>
